import React, { useState } from "react";
import styled from "styled-components";
import { Menu, X } from "lucide-react";

// Sample developer data
const developers = [
  {
    id: 1,
    name: "Rahul Mehta",
    avatar: "https://i.pravatar.cc/150?img=1",
    tech: ["React", "Node.js"],
    experience: 3,
    problemsSolved: 120,
    type: "Freelancer",
    openForJob: true,
  },
  {
    id: 2,
    name: "Anjali Sharma",
    avatar: "https://i.pravatar.cc/150?img=2",
    tech: ["Vue", "Laravel"],
    experience: 5,
    problemsSolved: 200,
    type: "Full Time",
    openForJob: false,
  },
  {
    id: 3,
    name: "Vikram Singh",
    avatar: "https://i.pravatar.cc/150?img=3",
    tech: ["Angular", "Java"],
    experience: 4,
    problemsSolved: 180,
    type: "Freelancer",
    openForJob: true,
  },
  // Add more mock devs as needed
];

const DevelopersScreen = () => {
  const [search, setSearch] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);

  const filteredDevelopers = developers.filter((dev) =>
    dev.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Wrapper>
      <TopBar>
        <SearchInput
          placeholder="Search developer by name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <FilterToggle onClick={() => setFilterOpen(!filterOpen)}>
          {filterOpen ? <X size={24} /> : <Menu size={24} />}
        </FilterToggle>
      </TopBar>

      <Main>
        <Filters open={filterOpen}>
          <h3>Filters</h3>
          <Label>Technology</Label>
          <input type="text" placeholder="React, Node.js..." />

          <Label>Experience</Label>
          <select>
            <option value="">All</option>
            <option value="1">1+ years</option>
            <option value="3">3+ years</option>
            <option value="5">5+ years</option>
          </select>

          <Label>Problems Solved</Label>
          <select>
            <option value="">All</option>
            <option value="50">50+</option>
            <option value="100">100+</option>
            <option value="200">200+</option>
          </select>

          <Label>Type</Label>
          <select>
            <option value="">All</option>
            <option value="Freelancer">Freelancer</option>
            <option value="Full Time">Full Time</option>
          </select>

          <Label>Open for Job</Label>
          <select>
            <option value="">All</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </Filters>

        <Grid>
          {filteredDevelopers.map((dev) => (
            <Card key={dev.id}>
              <Avatar src={dev.avatar} />
              <Name>{dev.name}</Name>
              <Meta>
                <b>Experience:</b> {dev.experience} yrs
              </Meta>
              <Meta>
                <b>Solved:</b> {dev.problemsSolved} problems
              </Meta>
              <Meta>
                <b>Type:</b> {dev.type}
              </Meta>
              <Meta>
                <b>Open for Job:</b> {dev.openForJob ? "Yes" : "No"}
              </Meta>
              <Tags>
                {dev.tech.map((tag) => (
                  <Tag key={tag}>{tag}</Tag>
                ))}
              </Tags>
            </Card>
          ))}
        </Grid>
      </Main>
    </Wrapper>
  );
};

export default DevelopersScreen;

const Wrapper = styled.div`
  color: white;
  padding: 1rem;
  background: #0a0a0a;
  min-height: 110vh;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const SearchInput = styled.input`
  padding: 0.5rem 1rem;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  border: none;
  background: #1e1e1e;
  color: white;
`;

const FilterToggle = styled.button`
  background: transparent;
  border: none;
  color: white;
  margin-left: 1rem;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Main = styled.div`
  display: flex;
`;

const Filters = styled.div`
  width: 250px;
  background: #1a1a1a;
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    display: ${({ open }) => (open ? "flex" : "none")};
    position: absolute;
    z-index: 999;
    top: 70px;
    left: 0;
    height: 100vh;
    width: 80%;
  }
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: #aaa;
`;

const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
  margin-left: 1rem;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const Card = styled.div`
  background: #111;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 255, 200, 0.1);
  text-align: center;
`;

const Avatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
`;

const Name = styled.h3`
  margin: 0.5rem 0;
`;

const Meta = styled.p`
  font-size: 0.9rem;
  color: #bbb;
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: center;
  margin-top: 0.5rem;
`;

const Tag = styled.span`
  background: #00ffcb20;
  border: 1px solid #00ffcb;
  color: #00ffcb;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
  font-size: 0.8rem;
`;
